import React, { Component, PropTypes } from 'react'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import autoBind from 'react-autobind'
import getMuiTheme from 'material-ui/styles/getMuiTheme'
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme'
import { fetchArticle, editArticle, deleteArticle } from '../actions'
import Alert from '../components/home/Alert'
import _ from 'lodash'
import EditArticle from '../components/Articles/EditArticles'

const propTypes = {
  dispatch: PropTypes.func,
  isAuthenticated: PropTypes.bool,
  articles: PropTypes.object,
  error: PropTypes.any,
}

class ArticlesEditPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewRedirect: false,
      alertOpen: false,
      alertMessage: '',
      edited: false,
      article:{},
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillMount() {
    // if (!this.props.isAuthenticated) {
    //   browserHistory.push('/');
    // }
    console.log('this.props.articleId', this.props.articleId)
    this.props.dispatch(fetchArticle(this.props.articleId))
  }
  componentWillReceiveProps(nextProps) {
    if(this.props.article !== nextProps.article) this.setState({article: nextProps.article})
    if (nextProps.error) {
      this.setState({
        alertOpen: true,
        error: true,
        alertMessage: `${nextProps.error.statusCode} ${nextProps.error.error} ${nextProps.error.message}`,
      });
    }
    // if (nextProps.article && !nextProps.error) {
    //   this.setState({
    //     alertOpen: true,
    //     error: false,
    //     alertMessage: 'Article saved successfully!',
    //   });
    // }
  }
  saveEditArticle(article) {
    this.setState({
      edited: true,
    });
    this.props.dispatch(editArticle(article));
  }
  deleteArticle(data) {
    const { article } = this.props
    this.setState({ article });
    this.props.dispatch(deleteArticle(data));
    browserHistory.push('/articles');
  }
  render() {
    console.log('article', this.props.article)
    const authPage = {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    };
    return (
      <div className="articles component" style={authPage}>
        <Alert
          alertOpen={this.state.alertOpen}
          alertHandleClose={() => this.alertHandleClose()}
          alertMessage={this.state.alertMessage}
        />
        <EditArticle 
          article={this.state.article}
          onSave={data => this.saveEditArticle(data)}
          onDelete={data => this.deleteArticle(data)}
          />
      </div>
    );
  }
}

ArticlesEditPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

ArticlesEditPage.propTypes = propTypes;

function mapStateToProps(state, ownProps) {
  return {
    articleId: ownProps.params.id,
    article: state.articles.article && state.articles.article[0]
  };
}

export default withRouter(connect(mapStateToProps)(ArticlesEditPage))



// WEBPACK FOOTER //
// ./src/containers/ArticlesEditPage.js